import React, { Profiler, useState } from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';

import SEO from '../components/Seo';
import Layout from '../components/Layout';
import NotePreview from '../components/NotePreview';
import Select from '../components/StyledComponents/Select';

const NoteControlsWrapper = styled.section`
	span.note-type-chip {
		line-height: 22px;
		font-family: var(--font-heading);
	}

	span.note-type-chip.active {
		border-width: 2px;
		font-weight: bold;
		color: var(--color-dark-background);
		border-color: var(--color-tertiary);
		background-color: var(--color-tertiary);
	}
`;

const noteTypes = [
	{ label: 'All', value: 'All' },
	{ label: 'Movies', value: 'movie' },
	{ label: 'TV', value: 'tv' },
	{ label: 'Music', value: 'music' },
];

const noteSortOptions = [
	{
		value: 1,
		label: 'Most Recent',
	},
	{
		value: 2,
		label: 'Oldest',
	},
	{
		value: 3,
		label: 'Rating: High to Low',
	},
	{
		value: 4,
		label: 'Rating: Low to High',
	},
];

const getSortKey = (value) => {
	if (value == 1) {
		return 'date-dsc';
	} else if (value == 2) {
		return 'date-asc';
	} else if (value == 3) {
		return 'rating-dsc';
	} else if (value == 4) {
		return 'rating-asc';
	}

	return 'date-dsc';
};

const NoteControls = ({ sort, filterByType, currentNoteType }) => {
	return (
		<NoteControlsWrapper className="flex flex-col sm:flex-row justify-between py-1 sm:mb-8">
			<div className="note-controls-filters flex mb-4 sm:mb-2">
				{noteTypes.map((noteType) => {
					const baseClass =
						'note-type-chip text-xs md:text-sm py-1 px-4 md:py-1 md:px-4 mr-4 cursor-pointer border rounded';
					const activeClass = `active ${baseClass}`;
					const isActive = noteType.value === currentNoteType;

					return (
						<span
							key={noteType.value}
							onClick={() => filterByType(noteType.value)}
							className={isActive ? activeClass : baseClass}
						>
							{noteType.label}
						</span>
					);
				})}
			</div>
			<div className="note-controls-sorter mb-4 sm:mb-0">
				<Select onChange={sort} options={noteSortOptions} />
			</div>
		</NoteControlsWrapper>
	);
};

const NoteList = ({ notes }) => {
	const [currentNoteType, updateCurrentNoteType] = useState('All');
	const [notesList, updateNotesList] = useState(notes);

	const filterByType = (type) => {
		updateCurrentNoteType(type);

		if (type === 'All') {
			updateNotesList(notes);

			return;
		}

		const filteredNotes = notes.filter(
			(note) => note.node.frontmatter.noteType === type,
		);

		updateNotesList(filteredNotes);
	};

	const sort = (e) => {
		e.persist();

		const [sortKey, sortDir = 'dsc'] = getSortKey(e.target.value).split('-');
		// console.log(e.target.value, sortKey, sortDir);

		const sortedNotes = [...notesList];

		sortedNotes.sort((a, b) => {
			const compValueA =
				sortKey === 'date'
					? new Date(a.node.frontmatter[sortKey])
					: a.node.frontmatter[sortKey];

			const compValueB =
				sortKey === 'date'
					? new Date(b.node.frontmatter[sortKey])
					: b.node.frontmatter[sortKey];

			if (sortDir === 'asc') {
				return compValueA - compValueB;
			}

			return compValueB - compValueA;
		});

		updateNotesList(sortedNotes);
	};

	const list = notesList.map((note, index) => {
		const isLastNote = index === notesList.length - 1;
		// console.log(note);

		return (
			<NotePreview key={note.node.id} note={note} isLastNote={isLastNote} />
		);
	});

	return (
		<>
			<NoteControls
				sort={sort}
				currentNoteType={currentNoteType}
				filterByType={filterByType}
			/>
			{list}
		</>
	);
};

// function onRenderCallback(
// 	id, // the "id" prop of the Profiler tree that has just committed
// 	phase, // either "mount" (if the tree just mounted) or "update" (if it re-rendered)
// 	actualDuration, // time spent rendering the committed update
// 	baseDuration, // estimated time to render the entire subtree without memoization
// 	startTime, // when React began rendering this update
// 	commitTime, // when React committed this update
// 	interactions, // the Set of interactions belonging to this update
// ) {
// 	console.log('id', id);
// 	console.log('phase', phase);
// 	console.log('actualDuration', actualDuration);
// 	console.log('baseDuration', baseDuration);
// 	console.log('startTime', startTime);
// 	console.log('commitTime', commitTime);
// 	console.log('interactions', interactions);
// }

const Notes = ({ data, location }) => {
	// console.log('DATA', data);
	const notes = data.allMdx.edges;
	console.log('Render');

	return (
		<Layout location={location} title="Notes">
			<SEO title="Notes" />
			{/* <Bio /> */}
			<div className="notes-list">
				{/* <Profiler id="NoteList" onRender={onRenderCallback}> */}
				<NoteList notes={notes} />
				{/* </Profiler> */}
			</div>
		</Layout>
	);
};

export default Notes;

export const pageQuery = graphql`
	query Notes {
		allMdx(
			filter: { frontmatter: { published: { eq: true }, type: { eq: "note" } } }
			sort: { order: DESC, fields: frontmatter___date }
		) {
			edges {
				node {
					id
					body
					frontmatter {
						description
						title
						date(formatString: "MMMM DD, YYYY")
						noteType
						rating
						slug
						type
						author
						year
						cover {
							childImageSharp {
								fluid(maxWidth: 215, quality: 100) {
									...GatsbyImageSharpFluid
								}
							}
						}
					}
				}
			}
		}
	}
`;
